import React from "react";
import { Navbar } from "./Navbar";
import { Footer } from "./Footer";

export const Layout = ({ children }) => (
  <div className="grain min-h-screen flex flex-col bg-ink">
    <Navbar />
    <main className="flex-1 relative z-10">{children}</main>
    <Footer />
  </div>
);
